import script from "./ViewGroupTalk.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewGroupTalk.vue?vue&type=script&setup=true&lang=js"

import "./ViewGroupTalk.vue?vue&type=style&index=0&id=2b6d25ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b6d25ba"]])

export default __exports__